<template>
<div class="chapter">
<div class="inner_page">
<div class="plates" id="plates26">
<p class="centerImage"><img alt="images" id="plate26" src="images/plate26.jpg"/></p>
<p class="caption">My personal Spitfire Vc – BR539 – before the squadron and individual codes of DL-X have been applied. Below is the Hunter River, near Sydney.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 04_TallyHo_plates26.vue?3d3a3dfc